import { Box, Divider, Drawer, Stack, Typography } from "@mui/material";
import { blue } from "@mui/material/colors";
import MiniDrawer from "./Components/Drawer";
import { useLocation } from "react-router-dom";
import { createContext } from "react";



export const DataContext = createContext();

function InitHrm() {
  const { state } = useLocation();
  
  return (
    <>
      <Stack>
        <Box>
          <DataContext.Provider value={state}>
            <MiniDrawer />
          </DataContext.Provider>
        </Box>
      </Stack>
    </>
  );
}

export default InitHrm;
